import React, { useState } from "react";
import axios from "axios";

export default function ForgotPassword() {
  const API_BASE = import.meta.env.VITE_API_BASE_URL;
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus("");

    try {
      await axios.post(`${API_BASE}/api/users/request-password-reset`, {
        email,
      });
      setStatus(
        "If that email is registered, you’ll receive a reset link shortly."
      );
    } catch (err) {
      console.error("Forgot password error:", err);
      setStatus("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 pt-20">
      <div className="max-w-sm w-full bg-white rounded-2xl shadow-md border border-gray-100 p-6">
        <h1 className="text-xl font-semibold mb-2 text-center">
          Reset your password
        </h1>
        <p className="text-xs text-gray-500 mb-4 text-center">
          Enter the email you use for RelaxB and we’ll send you a reset link.
        </p>

        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="text-xs text-gray-700">Email</label>
            <input
              type="email"
              className="w-full mt-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-black focus:border-black"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="you@example.com"
            />
          </div>

          {status && (
            <div className="text-xs text-gray-600 bg-gray-50 border border-gray-200 px-3 py-2 rounded-lg">
              {status}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            className={`w-full py-2.5 text-white rounded-full font-medium transition ${
              submitting
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-black hover:bg-gray-900"
            }`}
          >
            {submitting ? "Sending..." : "Send reset link"}
          </button>
        </form>
      </div>
    </div>
  );
}
